import { WorkoutInterval, WorkoutMode } from '@kinomap-dev/ng-ui-lib/core';
import { SectionModelType, WorkoutSectionModeType } from '../types/section.type';
import { WORKOUT_MODE_FIELDS } from '../configs/sections-editor/workout-mode-fields.config';
import { generateSectionId } from './default-section';
import { secondsToDuration } from './duration.utils';

export const convertApiWorkoutIntervalsToSections = (
  intervals: WorkoutInterval[],
  mode: WorkoutMode,
): SectionModelType[] => {
  const [primaryField, secondaryField] = WORKOUT_MODE_FIELDS[mode];
  const seenOrders: Set<number> = new Set();

  return [...intervals]
    .filter((interval: WorkoutInterval) => {
      if (seenOrders.has(interval.order)) return false;
      seenOrders.add(interval.order);
      return true;
    })
    .map((interval: WorkoutInterval) => {
      const data: Record<string, number> = { [primaryField.key]: interval.value };

      if (secondaryField) data[secondaryField.key] = interval.value_secondary ?? 0;
      const cadence: number | undefined = (interval.optimal_cadence as number | null) ?? undefined;

      return {
        id: generateSectionId(),
        data: data as WorkoutSectionModeType,
        duration: secondsToDuration(interval.time),
        cadence,
      };
    });
};
